export enum EUnsubscribeStep {
  ARE_YOU_SURE = 'are_you_sure',
  REASON = 'reason',
  SKIP_THIS_MONTH = 'skip_this_month',
}

export enum EStopUsingLumiReason {
  OUTFIT_SUGGESTIONS = 'OUTFIT_SUGGESTIONS',
  SESSION_EXPECTATIONS = 'SESSION_EXPECTATIONS',
  TECHNICAL_ISSUES = 'TECHNICAL_ISSUES',
  CONTENT_QUALITY = 'CONTENT_QUALITY',
  NOT_WHAT_I_THOUGHT = 'NOT_WHAT_I_THOUGHT',
  OTHER = 'OTHER',
}

export enum ABTestGroup {
  GROUP_A = 'group_a',
  GROUP_B = 'group_b',
}

export enum EUnsubscribeReasonsStep {
  REASON = 'REASON',
  SUB_REASONS = 'SUB_REASONS',
  OFFER = 'OFFER',
}

export enum EOutfitSuggestionSubReason {
  DIDNT_MATCH_PREFERENCES = 'DIDNT_MATCH_PREFERENCES',
  NOT_SUITABLE = 'NOT_SUITABLE',
  TOO_EXPENSIVE = 'TOO_EXPENSIVE',
  TOO_FEW_OPTIONS = 'TOO_FEW_OPTIONS',
  NOT_AGE_APPROPRIATE = 'NOT_AGE_APPROPRIATE',
  SIMILAR_OUTFITS = 'SIMILAR_OUTFITS',
  POOR_SHOPS_SELECTION = 'POOR_SHOPS_SELECTION',
  MODELS_LOOK = 'MODELS_LOOK',
  OTHER = 'OTHER',
}

export enum ESessionExpectationsSubReason {
  STYLIST_DIDNT_UNDERSTAND = 'STYLIST_DIDNT_UNDERSTAND',
  STYLIST_LATE_OR_SHOW_UP = 'STYLIST_LATE_OR_SHOW_UP',
  STYLIST_RESPONDED_SLOWLY = 'STYLIST_RESPONDED_SLOWLY',
  STYLIST_UNPREPARED = 'STYLIST_UNPREPARED',
  RUSHED_OR_DISORNAZIED = 'RUSHED_OR_DISORNAZIED',
  TECHNICAL_ISSUES = 'TECHNICAL_ISSUES',
  EXPECTED_VOICE_OR_VIDEO = 'EXPECTED_VOICE_OR_VIDEO',
  NOT_REAL_PERSON = 'NOT_REAL_PERSON',
  OTHER = 'OTHER',
}

export enum ETechnicalIssuesSubReason {
  APP_CRASHED = 'APP_CRASHED',
  TECHNICAL_PROBLEMS = 'TECHNICAL_PROBLEMS',
  CHECKOUT_OR_PAYMENT_PROBLEMS = 'CHECKOUT_OR_PAYMENT_PROBLEMS',
  LOGIN_PROBLEMS = 'LOGIN_PROBLEMS',
  SHOPPING_ISSUE = 'SHOPPING_ISSUE',
  PERFORMANCE_ISSUE = 'PERFORMANCE_ISSUE',
  OTHER = 'OTHER',
}

export enum EContentQualitySubReason {
  REPETITIVE = 'REPETITIVE',
  NOT_RELEVANT = 'NOT_RELEVANT',
  VISUALS_NOT_ENGAGING = 'VISUALS_NOT_ENGAGING',
  NOT_USEFUL_INFO = 'NOT_USEFUL_INFO',
  CONTENT_LOW_QUALITY = 'CONTENT_LOW_QUALITY',
  OTHER = 'OTHER',
}
